/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TableStatus from './TableStatus';
import TaskInTableResponse from './TaskInTableResponse';

/**
 * The GetTableResponse model module.
 * @module model/GetTableResponse
 * @version 2.8.0
 */
class GetTableResponse {
    /**
     * Constructs a new <code>GetTableResponse</code>.
     * @alias module:model/GetTableResponse
     * @param id {String} 
     * @param name {String} 
     * @param path {String} 
     * @param status {module:model/TableStatus} 
     * @param creationDate {String} 
     * @param lastModificationDate {String} 
     * @param isTableFileStillExisting {Boolean} 
     */
    constructor(id, name, path, status, creationDate, lastModificationDate, isTableFileStillExisting) { 
        
        GetTableResponse.initialize(this, id, name, path, status, creationDate, lastModificationDate, isTableFileStillExisting);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, path, status, creationDate, lastModificationDate, isTableFileStillExisting) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['path'] = path;
        obj['status'] = status;
        obj['creationDate'] = creationDate;
        obj['lastModificationDate'] = lastModificationDate;
        obj['isTableFileStillExisting'] = isTableFileStillExisting;
    }

    /**
     * Constructs a <code>GetTableResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetTableResponse} obj Optional instance to populate.
     * @return {module:model/GetTableResponse} The populated <code>GetTableResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetTableResponse();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('path')) {
                obj['path'] = ApiClient.convertToType(data['path'], 'String');
            }
            if (data.hasOwnProperty('projectCollection')) {
                obj['projectCollection'] = ApiClient.convertToType(data['projectCollection'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = TableStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
            if (data.hasOwnProperty('lastModificationDate')) {
                obj['lastModificationDate'] = ApiClient.convertToType(data['lastModificationDate'], 'String');
            }
            if (data.hasOwnProperty('preprocessingTask')) {
                obj['preprocessingTask'] = TaskInTableResponse.constructFromObject(data['preprocessingTask']);
            }
            if (data.hasOwnProperty('annotationTask')) {
                obj['annotationTask'] = TaskInTableResponse.constructFromObject(data['annotationTask']);
            }
            if (data.hasOwnProperty('isTableFileStillExisting')) {
                obj['isTableFileStillExisting'] = ApiClient.convertToType(data['isTableFileStillExisting'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
GetTableResponse.prototype['id'] = undefined;

/**
 * @member {String} name
 */
GetTableResponse.prototype['name'] = undefined;

/**
 * @member {String} path
 */
GetTableResponse.prototype['path'] = undefined;

/**
 * @member {String} projectCollection
 */
GetTableResponse.prototype['projectCollection'] = undefined;

/**
 * @member {module:model/TableStatus} status
 */
GetTableResponse.prototype['status'] = undefined;

/**
 * @member {String} creationDate
 */
GetTableResponse.prototype['creationDate'] = undefined;

/**
 * @member {String} lastModificationDate
 */
GetTableResponse.prototype['lastModificationDate'] = undefined;

/**
 * @member {module:model/TaskInTableResponse} preprocessingTask
 */
GetTableResponse.prototype['preprocessingTask'] = undefined;

/**
 * @member {module:model/TaskInTableResponse} annotationTask
 */
GetTableResponse.prototype['annotationTask'] = undefined;

/**
 * @member {Boolean} isTableFileStillExisting
 */
GetTableResponse.prototype['isTableFileStillExisting'] = undefined;






export default GetTableResponse;

